/*! License details at fancyapps.com/license */
var e = function e(_e) {
  var t = new DOMParser().parseFromString(_e, "text/html").body;
  if (t.childElementCount > 1) {
    for (var n = document.createElement("div"); t.firstChild;) n.appendChild(t.firstChild);
    return n;
  }
  var r = t.firstChild;
  return !r || r instanceof HTMLElement ? r : ((n = document.createElement("div")).appendChild(r), n);
};
export { e as stringToHtml };